import { Temporal } from '@js-temporal/polyfill';

export const convertDurationStringToDuration = (durationString: string): Temporal.Duration =>
  Temporal.Duration.from(durationString);

export const convertHoursStringToDuration = (hours: number): Temporal.Duration => Temporal.Duration.from({ hours });
